var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.story
    ? _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "update-story",
        },
        [
          _c("section", { staticClass: "header" }, [
            _c("div", { staticClass: "col" }, [
              _c(
                "div",
                { staticClass: "mb-15 row" },
                [
                  _c("div", { staticClass: "desc require" }, [
                    _vm._v("故事名称"),
                  ]),
                  _c("el-input", {
                    attrs: { placeholder: "请输入故事名称" },
                    model: {
                      value: _vm.story.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.story, "name", $$v)
                      },
                      expression: "story.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "row mb-15" },
                [
                  _c("div", { staticClass: "desc" }, [_vm._v("故事分类")]),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        "value-key": "code",
                        placeholder: "请选择故事分类",
                      },
                      model: {
                        value: _vm.storyType.value,
                        callback: function ($$v) {
                          _vm.$set(_vm.storyType, "value", $$v)
                        },
                        expression: "storyType.value",
                      },
                    },
                    _vm._l(_vm.typeList, function (type, i) {
                      return _c("el-option", {
                        key: type.code,
                        attrs: { label: type.value, value: type },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "row" },
                [
                  _c("div", { staticClass: "desc" }, [_vm._v("场景")]),
                  _c(
                    "el-select",
                    {
                      ref: "sceneSelect",
                      attrs: {
                        "value-key": "scene",
                        placeholder: "请选择场景",
                      },
                      on: { change: _vm.changeScene },
                      model: {
                        value: _vm.currentScene,
                        callback: function ($$v) {
                          _vm.currentScene = $$v
                        },
                        expression: "currentScene",
                      },
                    },
                    _vm._l(_vm.scenes, function (scene, i) {
                      return _c(
                        "el-option",
                        {
                          key: scene.scene,
                          attrs: { label: scene.scene, value: scene },
                        },
                        [
                          _c("span", [_vm._v(_vm._s(scene.scene))]),
                          _c("i", {
                            staticClass: "el-icon-remove-outline del-icon",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.delScene(i, scene)
                              },
                            },
                          }),
                        ]
                      )
                    }),
                    1
                  ),
                  _c("i", {
                    staticClass: "el-icon-circle-plus-outline add-icon",
                    on: { click: _vm.addScene },
                  }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "col" }, [
              _c(
                "div",
                { staticClass: "row" },
                [
                  _c("div", { staticClass: "desc" }, [_vm._v("故事描述")]),
                  _c("el-input", {
                    attrs: {
                      rows: "3",
                      type: "textarea",
                      placeholder: "请输入故事描述",
                    },
                    model: {
                      value: _vm.story.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.story, "description", $$v)
                      },
                      expression: "story.description",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c(
              "div",
              { staticClass: "col" },
              [
                _c("el-button", { on: { click: _vm.saveData } }, [
                  _vm._v("保存"),
                ]),
              ],
              1
            ),
          ]),
          JSON.stringify(_vm.currentScene) !== "{}" && !_vm.currentScene.del
            ? _c("section", { staticClass: "content" }, [
                _c("div", { staticClass: "scene" }, [
                  _c("div", { staticClass: "col" }, [
                    _c(
                      "div",
                      { staticClass: "mb-15 row" },
                      [
                        _c("div", { staticClass: "desc require" }, [
                          _vm._v("场景名称"),
                        ]),
                        _c("el-input", {
                          attrs: { placeholder: "请输入场景名称" },
                          model: {
                            value: _vm.currentScene.scene,
                            callback: function ($$v) {
                              _vm.$set(_vm.currentScene, "scene", $$v)
                            },
                            expression: "currentScene.scene",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "row" },
                      [
                        _c("div", { staticClass: "desc" }, [_vm._v("步骤")]),
                        _c(
                          "el-select",
                          {
                            attrs: {
                              "value-key": "task",
                              placeholder: "请选择步骤",
                            },
                            model: {
                              value: _vm.currentTask,
                              callback: function ($$v) {
                                _vm.currentTask = $$v
                              },
                              expression: "currentTask",
                            },
                          },
                          _vm._l(_vm.currentScene.tasks, function (task, t_i) {
                            return _c(
                              "el-option",
                              {
                                key: task.task,
                                attrs: { label: task.task, value: task },
                              },
                              [
                                _c("span", [_vm._v(_vm._s(task.task))]),
                                _c("i", {
                                  staticClass:
                                    "el-icon-remove-outline del-icon",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.delTask(t_i, task)
                                    },
                                  },
                                }),
                              ]
                            )
                          }),
                          1
                        ),
                        _c("i", {
                          staticClass: "el-icon-circle-plus-outline add-icon",
                          on: { click: _vm.addTask },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "col" }, [
                    _c(
                      "div",
                      { staticClass: "row" },
                      [
                        _c("div", { staticClass: "desc" }, [
                          _vm._v("场景描述"),
                        ]),
                        _c("el-input", {
                          attrs: {
                            rows: "3",
                            type: "textarea",
                            placeholder: "请输入场景描述",
                          },
                          model: {
                            value: _vm.currentScene.description,
                            callback: function ($$v) {
                              _vm.$set(_vm.currentScene, "description", $$v)
                            },
                            expression: "currentScene.description",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
          JSON.stringify(_vm.currentTask) !== "{}" && !_vm.currentTask.del
            ? _c("section", { staticClass: "task" }, [
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c("div", { staticClass: "desc require" }, [
                          _vm._v("步骤名称"),
                        ]),
                        _c("el-input", {
                          attrs: { placeholder: "请输入步骤名称" },
                          model: {
                            value: _vm.currentTask.task,
                            callback: function ($$v) {
                              _vm.$set(_vm.currentTask, "task", $$v)
                            },
                            expression: "currentTask.task",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c("div", { staticClass: "desc" }, [
                          _vm._v("步骤描述"),
                        ]),
                        _c("el-input", {
                          attrs: {
                            rows: "3",
                            type: "textarea",
                            placeholder: "请输入步骤描述",
                          },
                          model: {
                            value: _vm.currentTask.description,
                            callback: function ($$v) {
                              _vm.$set(_vm.currentTask, "description", $$v)
                            },
                            expression: "currentTask.description",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "row qas" },
                  [
                    _c("el-col", { attrs: { span: 12 } }, [
                      _c("div", { staticClass: "mb-15" }, [_vm._v("问答合集")]),
                      _c(
                        "div",
                        { staticClass: "auto" },
                        _vm._l(_vm.currentTask.qaPairs, function (qas, index) {
                          return _c("div", { key: index }, [
                            _c(
                              "div",
                              { staticClass: "qa" },
                              [
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "require",
                                    attrs: { span: 6 },
                                  },
                                  [_vm._v("问题：")]
                                ),
                                _c(
                                  "el-col",
                                  { attrs: { span: 18 } },
                                  _vm._l(qas.questions, function (qa, i) {
                                    return _c(
                                      "div",
                                      { key: i },
                                      [
                                        _c("el-input", {
                                          attrs: { type: "textarea", rows: 2 },
                                          model: {
                                            value: qas.questions[i],
                                            callback: function ($$v) {
                                              _vm.$set(qas.questions, i, $$v)
                                            },
                                            expression: "qas.questions[i]",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  }),
                                  0
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "qa" },
                              [
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "require",
                                    attrs: { span: 6 },
                                  },
                                  [_vm._v("答案：")]
                                ),
                                _c(
                                  "el-col",
                                  { attrs: { span: 18 } },
                                  [
                                    _c("el-input", {
                                      attrs: { type: "textarea", rows: 4 },
                                      model: {
                                        value: qas.answer,
                                        callback: function ($$v) {
                                          _vm.$set(qas, "answer", $$v)
                                        },
                                        expression: "qas.answer",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "qa" },
                              [
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "require",
                                    attrs: { span: 6 },
                                  },
                                  [_vm._v("问题意图：")]
                                ),
                                _c(
                                  "el-col",
                                  { attrs: { span: 18 } },
                                  [
                                    _c("el-input", {
                                      attrs: { type: "textarea", rows: 2 },
                                      model: {
                                        value: qas.questionIntent,
                                        callback: function ($$v) {
                                          _vm.$set(qas, "questionIntent", $$v)
                                        },
                                        expression: "qas.questionIntent",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "qa" },
                              [
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "require",
                                    attrs: { span: 6 },
                                  },
                                  [_vm._v("答案意图：")]
                                ),
                                _c(
                                  "el-col",
                                  { attrs: { span: 18 } },
                                  [
                                    _c("el-input", {
                                      attrs: { type: "textarea", rows: 2 },
                                      model: {
                                        value: qas.answerIntent,
                                        callback: function ($$v) {
                                          _vm.$set(qas, "answerIntent", $$v)
                                        },
                                        expression: "qas.answerIntent",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ])
                        }),
                        0
                      ),
                    ]),
                    _c(
                      "el-col",
                      { staticClass: "checkList", attrs: { span: 12 } },
                      [
                        _c("div", { staticClass: "mb-15 require" }, [
                          _vm._v(" 检查点 "),
                          _c("i", {
                            staticClass: "el-icon-circle-plus-outline",
                            on: { click: _vm.addCheck },
                          }),
                        ]),
                        _c(
                          "div",
                          { staticClass: "auto" },
                          _vm._l(
                            _vm.currentTask.checkList,
                            function (check, c_i) {
                              return _c(
                                "div",
                                { key: c_i, staticClass: "check" },
                                [
                                  _c("el-input", {
                                    attrs: { type: "textarea", rows: 2 },
                                    model: {
                                      value: _vm.currentTask.checkList[c_i],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.currentTask.checkList,
                                          c_i,
                                          $$v
                                        )
                                      },
                                      expression: "currentTask.checkList[c_i]",
                                    },
                                  }),
                                  _c("i", {
                                    staticClass: "el-icon-remove-outline",
                                    on: {
                                      click: function ($event) {
                                        return _vm.currentTask.checkList.splice(
                                          c_i,
                                          1
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              )
                            }
                          ),
                          0
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }